import { loadStripe } from '@stripe/stripe-js';
import { type Stripe } from '@stripe/stripe-js';

export const loadStripePromise = async (): Promise<Stripe | null> => {
  const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY!);

  return stripePromise;
};
